<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,10C11.7,10,11.5,10.1,11.3,10.3C11.3,10.3,9,12.6,9,12.6C9,12.6,9,3.4,9,3.4C9,3.4,11.3,5.7,11.3,5.7C11.5,5.9,11.7,6,12,6C12.6,6,13,5.6,13,5C13,4.7,12.9,4.5,12.7,4.3C12.7,4.3,8.7,0.3,8.7,0.3C8.5,0.1,8.3,5.55112e-17,8,5.55112e-17C7.7,5.55112e-17,7.5,0.1,7.3,0.3C7.3,0.3,3.3,4.3,3.3,4.3C3.1,4.5,3,4.7,3,5C3,5.6,3.5,6,4,6C4.3,6,4.5,5.9,4.7,5.7C4.7,5.7,7,3.4,7,3.4C7,3.4,7,12.6,7,12.6C7,12.6,4.7,10.3,4.7,10.3C4.5,10.1,4.3,10,4,10C3.5,10,3,10.4,3,11C3,11.3,3.1,11.5,3.3,11.7C3.3,11.7,7.3,15.7,7.3,15.7C7.5,15.9,7.7,16,8,16C8.3,16,8.5,15.9,8.7,15.7C8.7,15.7,12.7,11.7,12.7,11.7C12.9,11.5,13,11.3,13,11C13,10.4,12.6,10,12,10C12,10,12,10,12,10C12,10,12,10,12,10Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ArrowsVertical',
} as DefineComponent
</script>
